<section class="tp-error-area pt-75 pb-110">
    <div class="container">
        <div class="row justify-content-center text-align-center">
            <!-- TODO: uncomment below code when the updated term and condition is provided by Viewbid -->
            <!-- <div class="col-xl-6 col-lg-8 col-md-10">
                <div class="max-w-6xl">
                    <div class="dynamic-content" [innerHtml]="getTnCTxt"></div>
                </div>
            </div> -->
            <h3>Please contact Viewbid for terms and conditions.</h3>
        </div>
    </div>
</section>
